'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('dplayer/dist/DPlayer.min.css');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _dplayer = require('dplayer');

var _dplayer2 = _interopRequireDefault(_dplayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var eventNames = ['abort', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'ended', 'error', 'loadeddata', 'loadedmetadata', 'loadstart', 'mozaudioavailable', 'pause', 'play', 'playing', 'progress', 'ratechange', 'seeked', 'seeking', 'stalled', 'suspend', 'timeupdate', 'volumechange', 'waiting'];
var capitalize = function capitalize(str) {
  return '' + str.charAt(0).toUpperCase() + str.substring(1);
};

var DPlayerComponent = function (_React$Component) {
  _inherits(DPlayerComponent, _React$Component);

  function DPlayerComponent(props, context) {
    _classCallCheck(this, DPlayerComponent);

    return _possibleConstructorReturn(this, _React$Component.call(this, props, context));
  }

  DPlayerComponent.prototype.componentDidMount = function componentDidMount() {
    //find otherProps
    var _props = this.props,
        onLoad = _props.onLoad,
        otherProps = _objectWithoutProperties(_props, ['onLoad']);
    //new empty componentEvents


    var componentEvents = [];
    //remove otherProps event saveTo componentEvents
    eventNames.forEach(function (eventName) {
      var funcName = 'on' + capitalize(eventName);
      var event = otherProps[funcName];
      if (event) {
        delete otherProps[funcName];
        componentEvents.push({ eventName: eventName, event: event });
      }
    });
    //new player
    var player = this.dp = new _dplayer2.default(_extends({}, otherProps, {
      element: this.ele
    }));
    //run load
    onLoad && onLoad(player);
    //bind player events
    componentEvents.forEach(function (eventObject) {
      var eventName = eventObject.eventName,
          event = eventObject.event;

      player.on(eventName, event);
    });
  };

  DPlayerComponent.prototype.render = function render() {
    var _classNames,
        _this2 = this;

    var _props2 = this.props,
        className = _props2.className,
        style = _props2.style,
        id = _props2.id;

    var wrapperClassName = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, 'dplayer', true), _defineProperty(_classNames, '' + className, !!className), _classNames));
    return _react2.default.createElement('div', { ref: function ref(_ref) {
        return _this2.ele = _ref;
      },
      id: id,
      style: style,
      className: wrapperClassName });
  };

  return DPlayerComponent;
}(_react2.default.Component);

DPlayerComponent.defaultProps = {
  lang: 'zh-cn',
  contextmenu: [{
    text: 'Author',
    link: 'http://89io.com'
  }, {
    text: 'GitHub',
    link: 'https://github.com/MoePlayer/react-dplayer'
  }]
};
DPlayerComponent.propTypes = {
  lang: _propTypes2.default.string,
  video: _propTypes2.default.shape({
    url: _propTypes2.default.string,
    pic: _propTypes2.default.string,
    type: _propTypes2.default.string,
    quality: _propTypes2.default.array,
    defaultQuality: _propTypes2.default.number
  }).isRequired
};

exports.default = DPlayerComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dplayer/lib/DPlayer.js
// module id = 54
// module chunks = 0